import React, { useState, useEffect, useRef } from 'react';
import Table from '../Common/table';
import axios from '../httpServices/httpService';
import api from '../config.json'
import swal from 'sweetalert';
import auth from '../httpServices/authService';
import validation from '../utill/validation';
import _, { cloneDeep, result } from 'lodash';
import joi, { object } from 'joi'
import Loading from '../utill/LoadingComponent';
import date from '../utill/dateTime';
// import EquipmentSelection from '../Common/equipmentSelection';
import { ToastContainer, toast } from 'react-toastify';
import DateSelection from '../Common/DateSelection';
import { Button, Modal, Select } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faFilePdf, faMinusCircle, faPlusCircle, faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/vg.png';
import ExportPdfButton from '../utill/ExportPdf';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import ProcessProductPatrolInspection from '../MARELLITALBROS/ProcessProductPatrolInspection';
import PokaYokeSheet from '../MARELLITALBROS/PokayokeMonitoringSheet';
import DailyInitialFlowManagement from '../MARELLITALBROS/DailyInitialFlowManagement';
import DataEntryReportView from '../MARELLITALBROS/DataEntryReportView';
import Tooltip from '../utill/tooltip';
import DailyInitialFlowManagement_PROCESS from '../MARELLITALBROS/DailyIMFFaridabad_Process_Parameter';
import PaginationComponent from '../Common/PaginationComponent';


const AlertReport = ({ handleDownloadTableToExcel, equips, equipGroups, fromDateLimit, Heading }) => {
    const reportType = [
        // { label: "Incoming Inspection", value: "Incoming", name: "IncomingInspection" },
        // { label: "First Part Inspection", value: "FirstPart", name: "FirstPartInspection" },
        // { label: "Inprocess Inspection", value: "Inprocess", name: "InProcessInspection" },
        // { label: "Last Part Inspection ", value: "LastPart", name: "LastPartInspection" },
        // { label: "FinishedGoods Inspection", value: "FinishedGoods", name: 'FG_Inspection' }
    ]
    const [qualityData, setQualityData] = useState([])
    const [inputData, setInputData] = useState({ From: new Date(), Till: new Date() })
    const [parts, setAllParts] = useState([]);
    const [types, setAllTypes] = useState([]);
    const [allTypeCache, setAllTypeCache] = useState([]);
    const [querySuccess, setQuerySuccess] = useState(false);
    const [sortColumn, setSortColumn] = useState({ path: 'PartID', order: 'asc' })
    const [open, setOpen] = useState(false);
    const [pdfOpen, setPdfOpen] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [checkPointTemplates, setCheckPointTemplates] = useState([]);
    const [company, setCompany] = useState({})
    const [loader, setLoader] = useState(false)
    const [methods, setMethods] = useState([])
    const [arrayLenght, setArrayLenght] = useState(0);
    const [allPartsCache, setAllPartsCache] = useState([]);
    const [itemNumber, setAllItemNumber] = useState([]);
    const [operations, setAllOperations] = useState([]);
    const [selectedTemplates, setSelectedTemplate] = useState({ Columns: [] })
    const [pdfData, setPdfData] = useState([])
    const [CurrentPage, setCurrentPage] = useState(1);
    const [TotalPage, setTotalPage] = useState(5);
    const [PageSize, setPageSize] = useState(25);

    const customerRef = useRef(null);
    // const filteredOptions = clients.filter((o) => !selectedItems.find(b => o.label == b));

    useEffect(() => {
        Heading('View Alerts')
        GetAllInspetcionTypes();
        getAllPart();
        getAllMethods();
        getCompanyDetail()
        getAllTemplate()
    }, [])

    const getCompanyDetail = () => {
        axios.get(api.api + 'company/' + auth.getCurrentUser().company)
            .then((result) => {
                setCompany(result.data)
            })
            .catch((err) => {
                console.error(err);
            });
    }




    const handleOnChange = (name, value) => {
        const obj = { ...inputData }
        obj[name] = value;
        setInputData(obj);
        console.log(obj);
        if (name == "InspectionType") {
            const numbers = allPartsCache
                .filter(one => one.Inspection.some(x => (value.includes(x.InspectionName)) && x.Enable) || value.includes("All"))
                .map(one => ({ label: one.ItemName, value: one.ItemName }));

            setAllParts(numbers);

        }
        if (name == "ItemName") {
            const numbers = allPartsCache.map((one) => {
                if (value.includes(one.ItemName) || value.includes("All")) {
                    return { label: one.ItemNumber, value: one.ItemNumber }
                }
            })
            setAllItemNumber(numbers.filter(x => x))

        }
        if (name == "ItemNumber") {
            const operations = allPartsCache.map((one) => {
                if ((inputData.ItemName && inputData.ItemName.includes(one.ItemName) || inputData.ItemName.includes("All")) && (value.includes(one.ItemNumber) || value.includes("All"))) {
                    return { label: one.Operation, value: one.Operation }
                }
            })
            setAllOperations(operations.filter(x => x));
        }
    }



    const getAllMethods = () => {
        axios.get(api.api + "method")
            .then((result) => {
                setMethods(result.data)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }


    const getAllInspection = () => {
        axios.get(api.api + "inspectionType")
            .then((result) => {
                const all = result.data.map((one) => { return { label: one.InspectionType, value: one.InspectionType } })
                setAllTypes(all)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }

    const getAllPart = () => {
        axios.get(api.api + "item")
            .then((result) => {
                setAllPartsCache(result.data)

                const all = result.data.map((one) => { return { label: one.ItemName, value: one.ItemName } })

                setAllParts(all)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }


    useEffect(() => {
        validateAndApply()

    }, [CurrentPage, PageSize]);

    const validateAndApply = () => {
        // if (!inputData.InspectionType || (inputData.InspectionType.length == 0)) {
        //     return
        // }
        if (!inputData.ItemName || (inputData.ItemName.length == 0)) {
            return
        }
        if (!inputData.ItemNumber || (inputData.ItemNumber.length == 0)) {
            return
        }
        if (!inputData.Operation || (inputData.Operation.length == 0)) {
            return
        }
        handleGetData()
    }

    const handleGetData = async () => {
        // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
        setLoader(true)
        axios.put(api.api + 'NotificationReport', { query: inputData, PageSize: PageSize, Page: CurrentPage, Remarks: "All" })
            .then((result) => {
                setLoader(false)
                setTotalPage(Math.ceil(result.data.totalDocuments / PageSize));
                setQualityData(result.data.data);
                //setArrayLenght(result.data.length > 0 ? result.data[0].Reports.length : 0)
            })
            .catch((err) => {
                setLoader(false)
                console.log(err);
            })
    }

    async function getBase64FromImageUrl(url) {
        try {
            // Fetch the image data from the URL
            const response = await fetch(url);
            const blob = await response.blob();

            // Create a FileReader to convert the Blob to base64
            const reader = new FileReader();

            return new Promise((resolve, reject) => {
                reader.onloadend = function () {
                    // Extract base64 string from the data URL
                    const base64String = reader.result.split(',')[1];
                    resolve(base64String);
                };

                reader.onerror = function (error) {
                    reject(error);
                };

                // Read the Blob as a data URL
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('Error fetching or converting image:', error);
            throw error;
        }
    }



    const handleGetPdfData = async (query) => {
        // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
        setLoader(true)
        axios.put(api.api + 'ViewReport', query)
            .then((result) => {
                setPdfData(result.data);
                setLoader(false)
            })
            .catch((err) => {
                setLoader(false)
                console.log(err);
            })
    }




    const handleInputChange = (parentIdx, index, e) => {
        const data = { ...qualityData };
        data[parentIdx].Standard[index][e.currentTarget.name] = e.currentTarget.value;

        setQualityData(qualityData)
    }

    const handleOnSubmit = () => {
        const data = [...qualityData];
        const obj = { PartID: inputData.PartID, InspectionType: inputData.InspectionType, DateTime: inputData.DateTime, Reports: [] }
        data.forEach((sample, index) => {
            const reports = { SampleSerial: index + 1, InspectionData: [] }
            sample.Standard.forEach((one, index) => {
                reports.InspectionData.push({ Parameter: one.Parameter, ObservedValue: one.ObservedValue, Result: one.Result, Remarks: one.Remarks, StandardType: one.StandardType })
            })
            obj.Reports.push(reports);
        })
        axios.post(api.api + "inspectionReport", obj)
            .then((result) => {
                setQualityData([])
                swal("Data Saved Successfully")
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const addMore = () => {
        const data = cloneDeep(qualityData);
        const obj = cloneDeep(data[data.length - 1])
        obj.Standard.forEach((one) => {
            delete one.ObservedValue
            delete one.Result
            delete one.Remarks
        })
        setQualityData([...data, obj]);
    }

    const removeRow = () => {
        let data = [...qualityData];
        data.splice(data.length - 1, 1)
        setQualityData(data);
    }



    const getStandardType = (obj) => {
        if (obj && obj.StandardType == "Dimension") {
            return `(Dimension (+${obj.PlusTolerance}/-${obj.MinusTolerance}))`
        }
        return `(Description)`
    }

    const extractInspectionDataSeparateArray = (data) => {

        const separateInspectionDataArray = [];

        // Iterate through each report
        if (data) {
            console.log(data, "testingthe data")
            data && data.Reports && data.Reports.forEach((report) => {
                // Iterate through InspectionData in the report
                report.InspectionData.forEach((inspection) => {
                    const parameter = inspection.Parameter;
                    const existingEntry = separateInspectionDataArray.find(entry => entry.Parameter === parameter);

                    if (existingEntry) {
                        existingEntry.InspectionData.push(inspection);
                    } else {
                        separateInspectionDataArray.push({
                            Parameter: parameter,
                            InspectionData: [inspection]
                        });
                    }
                });
            });
        }

        data.InspectionData = separateInspectionDataArray
        console.log(data, "data for the table")
        return [data];
    };

    const getRange = (one) => {
        let str = '-'
        if (one.StandardType == "Dimension") {
            const dim = parseFloat(one.Dimension)
            const plus = dim + parseFloat(one.PlusTolerance)
            const minus = dim - parseFloat(one.MinusTolerance)
            str = `( ${plus} - ${minus} ) ${one.UOM}`
        }

        return str
    }

    const getItem = () => {
        const item = allPartsCache.find(part => part.ItemName == reportData.Item && part.ItemNumber == reportData.ItemNumber && part.Operation == reportData.Operation);
        if (item) {
            return item
        }
        return {}
    }


    const reportTypes = ["Retrospective Inspection",
        "Setup Approval Inspection",
        "Process/Product Patrol Inspection",
        "Poka - Yoke Sheet",
        "IFM - Product - Msr",
        "IFM - Process - Fbd",
        "IFM_Product_FBD"

    ]
    const columns1 = [

        { path: "DateTime", label: "Date", content: (obj) => (<>{moment(obj.DateTime).format('DD-MM-YY')}</>) },
        { path: "DateTime", label: "Time", content: (obj) => (<>{moment(obj.DateTime).format('hh:mm')}</>) },
        { path: "ItemName", label: "Item Name" },
        { path: "ItemNumber", label: "Item Number" },
        { path: "Operation", label: "Operation" },
        { path: "LastInspection", label: "Last Inspection" },
        { path: "Stage", label: "Stage" },
        { path: "NotificationSentDetails", label: "Notification Send At", content: (obj) => (<>{moment(obj.NotificationSentDetails).format('DD-MM-YY hh:mm a')}</>) },
    ];

    const GetAllInspetcionTypes = () => {
        axios.get(api.api + 'customInspection')
            .then((result) => {
                const reports = [...reportType]
                result.data.forEach((one) => {
                    const obj = { label: one.InspectionType, value: one.InspectionType, name: one.InspectionType }
                    reports.push(obj)
                })
                setAllTypeCache(result.data)
                setAllTypes(reports)
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const getAllTemplate = () => {
        axios.get(api.api + "checkPointConfig")
            .then((result) => {
                setCheckPointTemplates(result.data)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }



    return (
        <React.Fragment>
            {loader ? <Loading labelShow={true} label={"Loading..."} /> : ''}
            {/* <div className='text-center' >
                <p >QMS Report</p>
            </div> */}

            {/* <ToastContainer /> */}

            <div className="row">
                <div className="col-sm-2">
                    <div className="form-group">
                        <label className='small'>From</label>
                        <input value={moment(inputData.From).format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChange('From', e.currentTarget.value)} type='date' />

                    </div>
                </div>
                <div className="col-sm-2">
                    <div className="form-group">
                        <label className='small'>Till</label>
                        <input value={moment(inputData.Till).format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChange('Till', e.currentTarget.value)} type='date' />

                    </div>
                </div>
                {/* <div className='col-sm-2'>
                    <label className='small text-center'>Inspection Type</label>
                    <Select
                        maxTagCount={"responsive"}
                        mode="multiple"
                        placeholder="Select Inspection Type"
                        value={inputData.InspectionType}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.InspectionType && (inputData.InspectionType.length === types.length)) {
                                    handleOnChange('InspectionType', []);
                                } else {
                                    handleOnChange('InspectionType', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('InspectionType', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={[
                            { label: 'All', value: 'All' },
                            ...types
                        ]}
                    />

                </div> */}
                <div className='col-sm-2'>
                    <label className='small text-center'>Item</label>
                    <Select
                        showSearch
                        maxTagCount={"responsive"}
                        mode="multiple"
                        placeholder="Select Item"
                        value={inputData.ItemName}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.ItemName && (inputData.ItemName.length === parts.length)) {
                                    // Deselect all if "Select All" was deselected
                                    handleOnChange('ItemName', []);
                                } else {
                                    // Select all
                                    handleOnChange('ItemName', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('ItemName', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={parts.length == 0 ? [] : [
                            { label: 'All', value: 'All' },
                            ..._.uniqBy(parts, "value")
                        ]}
                    />
                </div>
                <div className='col-sm-2'>
                    <label className='small text-center'>Item Number</label>
                    <Select
                        showSearch
                        maxTagCount={"responsive"}
                        mode="multiple"
                        placeholder="Select Item"
                        value={inputData.ItemNumber}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.ItemNumber && (inputData.ItemNumber.length === itemNumber.length)) {
                                    // Deselect all if "Select All" was deselected
                                    handleOnChange('ItemNumber', []);
                                } else {
                                    // Select all
                                    handleOnChange('ItemNumber', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('ItemNumber', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={itemNumber.length == 0 ? [] : [
                            { label: 'All', value: 'All' },
                            ..._.uniqBy(itemNumber, "value")
                        ]}
                    />
                </div>
                <div className='col-sm-2'>
                    <label className='small text-center'>Operation</label>
                    <Select
                        showSearch
                        maxTagCount={"responsive"}
                        mode="multiple"
                        placeholder="Select Operation"
                        value={inputData.Operation}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.Operation && (inputData.Operation.length === operations.length)) {
                                    // Deselect all if "Select All" was deselected
                                    handleOnChange('Operation', []);
                                } else {
                                    // Select all
                                    handleOnChange('Operation', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('Operation', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={operations.length == 0 ? [] : [
                            { label: 'All', value: 'All' },
                            ..._.uniqBy(operations, "value")
                        ]}
                    />
                </div>

                <div className='col-sm-2'>
                    <label className='small text-center'>Alert Type</label>
                    <Select
                        showSearch
                        maxTagCount={"responsive"}
                        mode="multiple"
                        placeholder="Select Type"
                        value={inputData.AlertType}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.Operation && (inputData.Operation.length === operations.length)) {
                                    // Deselect all if "Select All" was deselected
                                    handleOnChange('AlertType', []);
                                } else {
                                    // Select all
                                    handleOnChange('AlertType', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('AlertType', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={operations.length == 0 ? [] : [
                            { label: 'All', value: 'All' },
                            ..._.uniqBy([{ label: 'NG', value: "NG" }, { label: 'Non Compliance', value: "NonCompliance" }], "value")
                        ]}
                    />
                </div>

                <div className="col-sm-1">
                    <button className='btn btn-primary btn-sm mt-4' onClick={() => {
                        // if (!inputData.InspectionType || (inputData.InspectionType.length == 0)) {
                        //     swal('Please select all inputs', { dangerMode: true });
                        //     return
                        // }
                        if (!inputData.ItemName || (inputData.ItemName.length == 0)) {
                            swal('Please select all inputs', { dangerMode: true });
                            return
                        }
                        else if (!inputData.ItemNumber || (inputData.ItemNumber.length == 0)) {
                            swal('Please select all inputs', { dangerMode: true });
                            return
                        }
                        else if (!inputData.Operation || (inputData.Operation.length == 0)) {
                            swal('Please select all inputs', { dangerMode: true });
                            return
                        }
                        handleGetData()
                    }}>Apply</button>
                </div>

            </div>






            {qualityData.length > 0 && <Table
                id="RejectionDetailedAnalysispiechart"
                onSort={() => { }}
                columns={columns1}
                sortColumn={sortColumn}
                // data={extractInspectionDataSeparateArray(qualityData[0])}

                data={qualityData}
            />}
            {qualityData.length > 0 && <div className="float-end m-3">
                {console.log(CurrentPage, TotalPage, "-------------------Test Report")}
                <PaginationComponent
                    current={CurrentPage}
                    pageSize={PageSize}
                    totalItems={TotalPage * PageSize}  // or just use total count
                    onPageChange={(page, size) => {
                        if (size !== PageSize) setCurrentPage(1);
                        else setCurrentPage(page);
                        setPageSize(size);
                    }}
                />
            </div>}

        </React.Fragment>
    );
}
export default AlertReport;